import { CellInfo } from 'react-table';
import React, { useMemo } from 'react';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { CustomActionCell, ListTable } from '../../../components';
import {
  getCreditListRequest,
  setCreditListDirty,
} from '../../../store/modules/credits/actions';
import { useActionDispatcher } from '../../../hooks';
import { selectCreditList } from '../../../store/modules/credits/selectors';
import { User } from '../../../types/items';
import useStyles from './styles';
import { InfoIcon } from '../../../components/icon/solid';

type Props = {
  user: User;
};

const CreditHistoryTable = ({ user }: Props) => {
  const classes = useStyles();
  const { loading, data, dirty } = useSelector(selectCreditList);
  const requiredFilters = useMemo(() => {
    return [{ key: 'user_id', value: user.id }];
  }, [user]);
  const getCreditList = useActionDispatcher(getCreditListRequest);
  const setDirty = useActionDispatcher(setCreditListDirty);

  return (
    <ListTable
      columns={[
        {
          id: 'created',
          Header: 'Date',
          minWidth: 60,
          maxWidth: 140,
          Cell: (cell: CellInfo) => (
            <div className={classes.nowrap}>
              {moment(cell.original.created * 1000).format('MMMM DD, YYYY')}
            </div>),
        },
        {
          id: 'source',
          Header: 'Description',
          minWidth: 80,
          Cell: (cell: CellInfo) => cell.original.ref?.source,
        },
        {
          id: 'video_credits_qty',
          Header: 'Credits',
          minWidth: 45,
        },
        {
          id: 'test',
          Header: 'Expiration',
          minWidth: 45,
        },
        {
          id: 'ref.subscription.product.title',
          Header: 'Plan',
          minWidth: 160,
          Cell: (cell: CellInfo) => (
            <div className={classes.nowrap}>
              {cell.original?.ref?.subscription.product.title}
            </div>),
        },
        {
          id: 'note',
          Header: 'Notes',
          maxWidth: 220,
          Cell: (cell: CellInfo) => (
            <div className={classes.noteWrapper}>
              <div className={classes.note}>
                {cell.original.note}
              </div>
              {cell.original.note
              && (
                <div>
                  <CustomActionCell
                    title={<InfoIcon className={classes.icon} />}
                    classNameButtonWrapper={classes.commentButtonWrapper}
                    onMouse
                  >
                    <div className={classes.comment}>
                      {cell.original.note.split('\n').map((str: string, index: number) => {
                        return <p key={index}>{str}</p>;
                      })}
                    </div>
                  </CustomActionCell>
                </div>
              )}
            </div>),
        },

      ]}
      loading={loading}
      data={data}
      fetch={getCreditList}
      requiredFilters={requiredFilters}
      dirty={Boolean(dirty)}
      setDirty={setDirty}
      hideSearch
      hideFilters
      viewEnable={false}
    />
  );
};

export default CreditHistoryTable;
